export default {"src":"/_next/static/media/austria.b512ddb9.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};